import script from "./DiscountSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscountSection.vue?vue&type=script&setup=true&lang=ts"

import "./DiscountSection.vue?vue&type=style&index=0&id=27a604fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a604fc"]])

export default __exports__